import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import { ProfileUserInformationModel } from "~~/package/mapper/profile/model/ProfileUserInformationModel";
import { ProfileUserAssessmentModel } from "~~/package/mapper/profile/model/ProfileUserAssessmentModel";
import { ProfileUserContestModel } from "~~/package/mapper/profile/model/ProfileUserContestModel";

export class ProfileModel extends Model {
    constructor(
        public userProfileVOV2: ProfileUserInformationModel = new ProfileUserInformationModel(),
        public otherUserProfileVO: ProfileUserInformationModel = new ProfileUserInformationModel(),
        public assessmentVOList: ProfileUserAssessmentModel[] = [],
        public contestVOList: ProfileUserContestModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<ProfileModel>): ProfileModel {
        return createModel<ProfileModel>(ProfileModel, { ...model });
    }
}
